import { Field as FormField } from '../../../gs-component-form';
import { FormBlockColumn, FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { Field as FormikField } from 'formik';
import React, { Fragment } from 'react';

interface Props {
  namePrefix?: string;
  disabledFields?: boolean;
}

export const CustomVendorFields: React.FC<Props> = ({ namePrefix = '', disabledFields = false }) => {
  return (
    <Fragment>
      <FormBlockColumn>
        <FormikField
          name={`${namePrefix}location.name`}
          label="Venue Name"
          component={FormField}
          disabled={disabledFields}
        />
      </FormBlockColumn>
      <FormBlockColumn>
        <FormikField
          name={`${namePrefix}location.street1`}
          label="Street Address"
          component={FormField}
          disabled={disabledFields}
        />
      </FormBlockColumn>
      <FormRow>
        <FormColumn xs="12" md>
          <FormikField
            name={`${namePrefix}location.city`}
            label="City"
            component={FormField}
            disabled={disabledFields}
          />
        </FormColumn>
        <FormColumn xs="12" md>
          <FormikField
            name={`${namePrefix}location.state`}
            label="State"
            component={FormField}
            disabled={disabledFields}
          />
        </FormColumn>
        <FormColumn xs="12" md>
          <FormikField name={`${namePrefix}location.zip`} label="Zip" component={FormField} disabled={disabledFields} />
        </FormColumn>
      </FormRow>
      <FormBlockColumn>
        <FormikField
          name={`${namePrefix}location.country`}
          label="Country"
          component={FormField}
          disabled={disabledFields}
        />
      </FormBlockColumn>
    </Fragment>
  );
};
